import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

import services from '@C/CashiersOnDuty/_utils/data';
import { formatCurrency } from '@C/TableGrid';
import { authHeader } from '@H';

import './styles.scoped.scss';

class EditCashSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cashier_id: this.props.cashier_id,
      cashier_duty_id: this.props.cashier_duty_id,
      cash_code: this.props.cash_code,
      cash_management_uuid: this.props.cash_management_uuid,
      time_stamp: this.props.time_stamp,
      denominationList: [],
      isSubmitting: false,
    };
  }

  componentDidMount() {
    this.getDenomination();
  }

  getDenomination = () => {
    const { cashier_duty_id, cash_code, cash_management_uuid } = this.state;

    services
      .getDenomination(cashier_duty_id, cash_code, cash_management_uuid)
      .then((response) => {
        const tmp = response.data.data;
        const cash_denomination = (tmp.cash_denomination || [])
          .filter((item) => item.denomination_details__value !== 2000)
          .map((item) => ({
            ...item,
            count: this.props.readOnly ? item.count || 0 : 0,
            amount: this.props.readOnly ? item.amount || 0 : 0,
            cash_code: this.state.cash_code,
            uuid: item.denomination_details__uuid,
          }));

        this.setState({
          denominationList: {
            ...tmp,
            cash_denomination,
          },
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  onInputChange = (e, i) => {
    const numericValue = e.target.value.replace(/\D/g, '');
    const denominationList = { ...this.state.denominationList };
    const cash_denomination = [...(denominationList.cash_denomination || [])];
    cash_denomination[i] = {
      ...cash_denomination[i],
      uuid: cash_denomination[i].denomination_details__uuid,
      count: numericValue === '' ? '' : +numericValue,
      amount:
        (numericValue === '' ? 0 : +numericValue) *
        cash_denomination[i].denomination_details__value,
      cash_code: this.state.cash_code,
      value: cash_denomination[i].denomination_details__value,
    };

    this.setState({
      denominationList: {
        ...denominationList,
        cash_denomination,
      },
    });
  };

  clearForm = () => {
    const clearedDenominationList =
      this.state.denominationList.cash_denomination.map((item) => ({
        ...item,
        count: 0,
        amount: 0,
      }));

    this.setState({
      denominationList: {
        ...this.state.denominationList,
        cash_denomination: clearedDenominationList,
      },
      isSubmitting: false,
    });
  };

  submitForm = (e) => {
    if (this.props.readOnly) {
      return;
    }
    e.preventDefault();

    this.setState({ isSubmitting: true });
    const formData = {
      cashier_duty_id: this.state.cashier_duty_id,
      time_stamp: this.state.time_stamp,
      cash_management_id: this.state.cash_management_uuid,
      cash_list: this.state.denominationList.cash_denomination.map((item) => ({
        count: item.count,
        uuid: item.uuid,
        cash_code: item.cash_code,
        amount: item.amount,
        value: item.value,
      })),
    };
    const headers = authHeader(1);
    axios
      .post(`${process.env.API_URL}/bunk/cash-denomination/`, formData, {
        headers,
      })
      .then(() => {
        toast.success('Cash details added successfully');
        this.setState({ isSubmitting: false });
        this.props.onRequestClose();
        this.props.updateDenomination();
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        this.setState({ isSubmitting: false });
      });
  };

  getSummaryAmount = () => {
    const apiAmount = Number(
      this.state.denominationList.cash_management_amount,
    );
    const fallbackAmount = Number(this.props.cashManagementAmount || 0);

    if (apiAmount > 0 || fallbackAmount === 0) {
      return apiAmount || 0;
    }

    return fallbackAmount;
  };

  render() {
    const { denominationList } = this.state;
    const totalAmount = denominationList.cash_denomination?.reduce(
      (a, b) => a + b['amount'],
      0,
    );
    const summaryAmount = this.getSummaryAmount();
    const summaryLabel =
      denominationList.cash_management_name ||
      this.props.cashManagementName ||
      'Cash in hand';
    const { showModal } = this.props;
    return (
      <>
        <section className="widget full-width form-table form-wrap">
          <header>
            <h3> Denomination </h3>
          </header>
          <main>
            <div className="form-content">
              <table>
                <thead>
                  <tr>
                    <th> Denomination</th>
                    <th> Count </th>
                    <th> Amount </th>
                  </tr>
                </thead>
                <tbody>
                  {denominationList.cash_denomination &&
                    denominationList.cash_denomination.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            <div className="input-wrapper denomination-cell">
                              {item.denomination_icon && (
                                <img
                                  className="img-input compact"
                                  src={item.denomination_icon}
                                  alt={`${item.denomination_details__value} note`}
                                />
                              )}
                              <span className="denomination-label">
                                {formatCurrency(
                                  item.denomination_details__value || 0,
                                  0,
                                )}
                              </span>
                            </div>
                          </td>
                          <td>
                            <div className="input-wrapper --wrap">
                              <input
                                type="text"
                                value={item.count}
                                name="count"
                                onChange={(e) => this.onInputChange(e, i)}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                disabled={showModal || this.props.readOnly}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-wrapper --wrap">
                              <div className="denomination-amount">
                                {formatCurrency(item.amount || 0)}
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className="form-actions">
              {!this.props.readOnly && (
                <button
                  className="submit"
                  type="submit"
                  onClick={this.clearForm}
                >
                  Clear
                </button>
              )}

              <button className="red-btn" onClick={this.props.onRequestClose}>
                Close
              </button>
              {!this.props.readOnly && (
                <button
                  className={`submit ${this.state.isSubmitting ? 'loading' : ''}`}
                  type="submit"
                  onClick={this.submitForm}
                >
                  Submit
                </button>
              )}
            </div>
          </main>
          <div className="table-wrapper">
            <div className="denomination-summary">
              <div className="summary-card">
                <span className="summary-label">{summaryLabel}</span>
                <strong className="summary-value">
                  {formatCurrency(summaryAmount || 0)}
                </strong>
              </div>
              <div className="summary-card highlight-total">
                <span className="summary-label">Denomination total</span>
                <strong className="summary-value">
                  {formatCurrency(totalAmount || 0)}
                </strong>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default EditCashSummary;
